import UsePostmortemInfo from "../../context/PostmortemContext";
import { validateInputs } from "./helpers/validateInpputs";
import { useAddCollaboratorsInTeamsChatService } from "../../services/addCollaboratorsInTeamsChatService";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import errorNotification from "../Notification/errorNotification";
import { loginRequest } from "../../auth/authConfig";
import { PostmortemServices } from "../../services/postmortemServices";
import { ImageServices } from "../../services/imageServices";
import { submitData } from "./helpers/submitdata";
import { getPostmortemData } from "./apiPayloadGeneratingFunctions/getPostmortemData";
import { saveImages } from "./helpers/saveImages";
import { removeImageFromContext } from "./helpers/removeImageFromContext";
import { changePostmortemStatusInStatusBar } from "./helpers/changePostmortemStatusInStatusBar";
import successNotification from "../Notification/successNotification";
import { HanldeStates } from "./states";
import UserInfo from "../../context/UserAccessContext";
import { useMsal } from "@azure/msal-react";
import { useFetchWithRetry } from "../../Utils/fetchWithRetry";
import { saveAuditData } from "./helpers/saveAuditData";
import { reinitializeTheChangeValues } from "./helpers/reinitializeTheChangeValues";
import { rcaMinScoreForSreReview, postmortemApiEndpoint } from "../../config";
import { ChainedFiveWhysService } from "../../services/chainedFiveWhysService";
import { ApprovalWorkflowServices } from "../../services/approvalWorkflowServices";
import { useQueryClient } from "react-query";
// import { useWebSocket } from "../../context/WebSocketContext/WebSocketContext";
export const UseEditors = (incidentID, postmortemID, edSignedOff) => {
  const [errMessage, setErrMessage] = useState(null);
  const [rcaChecking, setRcaChecking] = useState(false);
  const [chainedFiveWhysCount, setChainedFiveWhysCount] = useState(0);
  const [rcaBlockOpen, setRcaBlockOpen] = useState(false);
  const [rcaBlockData, setRcaBlockData] = useState(null);
  const [rcaQualityData, setRcaQualityData] = useState(null);
  const apiEndpoint = process.env.REACT_APP_POSTMORTEM_API_ENDPOINT;
  // const [postmortemTeamsChatData, setPostmortemTeamChatData] = useState("");
  const { instance, accounts } = useMsal();
  const queryClient = useQueryClient();
  const { fetchWithRetry } = useFetchWithRetry();
  const { graphData } = UserInfo();
  // const {updateCache} = useWebSocket()
  const updateCache = null; // WebSocket disabled
  const {
    postmortemState,
    memoizedDispatch,
    currentPostmortemObject,
    collaborators,
    setCollaborators,
    appOptionsAvailable,
    postmortemTeamId,
    updateContextPostmortemState,
    postmortemObjectForAuditing,
    setCurrentPostmortemObject,
    setPostmortemObjectForAuditing,
    resetChangedFieldsForStep // Add this to get the reset function from context
  } = UsePostmortemInfo();

  const postmortemStateRef = useRef(postmortemState);
  useEffect(() => {
    postmortemStateRef.current = postmortemState;
  }, [postmortemState]);

  // Fetch chained 5 whys count for validation
  const chainedService = ChainedFiveWhysService();
  useEffect(() => {
    if (!incidentID) return;
    chainedService.getChainedFiveWhysCached(queryClient, incidentID, instance, accounts)
      .then((chains) => setChainedFiveWhysCount(chains?.length || 0))
      .catch(() => setChainedFiveWhysCount(0));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incidentID]);

  const { postPostMortemData, fetchPostmortemById, postAuditData, getRcaQuality, fetchEnhancement } = PostmortemServices();
  const { addCollaboratorsinTeamsChatNew } =
    useAddCollaboratorsInTeamsChatService();
  const { postImage } = ImageServices();
  const approvalWorkflowService = ApprovalWorkflowServices();
  const {
    dataIsSavedSuccessfully,
    setDataIsSavedSuccessfully,
    imagesSavedSuccessfully,
    setImagesSavedSuccessfully,
    dataIsSubmittedSuccessfully,
    setDataIsSubmittedSuccessfully,
    uploading,
    setUploading,
    step,
    setStep,
    openModal,
    setOpenModal,
    message,
    setMessage,
    viewReport,
    setViewReport,
  } = HanldeStates();

  useEffect(() => {
    if (dataIsSavedSuccessfully && imagesSavedSuccessfully && !uploading) {
      setImagesSavedSuccessfully(false);

      toast.done("upload-progress");
      successNotification("Data saved successfully");
      // if(step === 2){
      //   return
      // }
      if (step > 2) {
        return;
      }
      // setDataIsSavedSuccessfully(false);
      if (
        currentPostmortemObject["priority"] === "3" ||
        currentPostmortemObject["priority"] === "4"
      ) {
        if (step === 3) {
          setStep((currStep) => currStep + 3);
        } else {
          setStep((currStep) => currStep + 1);;
        }
      } else {
        setStep(step + 1);
      }
    }
  }, [
    dataIsSavedSuccessfully,
    imagesSavedSuccessfully,
    setStep,
    step,
    uploading,
  ]);

  const saveData = (mode, saveFor, forcedStep) => {
    setViewReport(false);
    if (mode === "saving") {
      handleDataSubmit(mode, forcedStep);
    }
    if (mode === "submitting") {
      handleModalOpen();
      return;
    }
  };

  const handleModalOpen = () => {
    setOpenModal(!openModal);
  };

  const handleModalClose = () => {
    setMessage("");
    setOpenModal(false);
    setDataIsSubmittedSuccessfully(false);
  };

  const handleDataSubmit = async (mode, forcedStep) => {
    try {
      setUploading(true);

      // Re-fetch chained 5 whys count at submit time so chains added in this session are counted
      let freshChainedCount = chainedFiveWhysCount;
      if (incidentID) {
        try {
          const chains = await chainedService.getChainedFiveWhysCached(queryClient, incidentID, instance, accounts, { fresh: true });
          freshChainedCount = chains?.length || 0;
          setChainedFiveWhysCount(freshChainedCount);
        } catch {
          // fall back to cached value
        }
      }

      const { validInputs, inputRequiredFor, postmortemStep, postmortemPage } =
        validateInputs(postmortemState, appOptionsAvailable, freshChainedCount);

      const effectiveStep = forcedStep !== undefined ? forcedStep : step;

      if (mode === "submitting" && validInputs) {
        const prevState = postmortemState.postmortemCurrentStatus.currentState;

        // RCA quality gate disabled — re-enable when AI scoring is out of demo

        // Pre-flight: validate transition is allowed BEFORE submitting to backend
        const transitionCheck = changePostmortemStatusInStatusBar(
          () => { }, // no-op dispatch — dry run to check only
          prevState,
          postmortemState,
          currentPostmortemObject["priority"],
          edSignedOff || false
        );
        if (transitionCheck?.blocked) {
          errorNotification(transitionCheck.reason);
          setUploading(false);
          return;
        }

        // Save data first
        await submitDataAndImages(mode, effectiveStep);
        
        // Check if we're submitting for Leadership Review (new workflow)
        if (prevState === "DRAFT") {
          try {
            const userEmail = accounts[0]?.username || accounts[0]?.name || "unknown@maersk.com";
            
            // Old Platform Owner validation removed as it is now backend driven
            
            console.log("[APPROVAL-WORKFLOW] Validation passed, submitting for Leadership Review");
            await approvalWorkflowService.submitForLeadershipReview(instance, accounts, postmortemID, userEmail);
            successNotification("Submitted for Leadership Review. Email sent to ED and TLT.");
            // Reload to reflect new state
            setTimeout(() => window.location.reload(), 1500);
          } catch (error) {
            console.error("[APPROVAL-WORKFLOW] Failed to submit for Leadership Review:", error);
            errorNotification("Failed to submit for Leadership Review: " + (error.response?.data?.error || error.message));
          }
        } else {
          // Legacy flow for other states
          changePostmortemStatusInStatusBar(
            memoizedDispatch,
            prevState,
            postmortemState,
            currentPostmortemObject["priority"],
            edSignedOff || false
          );
        }
        
        await reinitializeTheChangeValues(effectiveStep, memoizedDispatch, postmortemState.changedFileds);
        setViewReport(true);
      } else if (mode === "saving") {
        await submitDataAndImages(mode, effectiveStep);
        await reinitializeTheChangeValues(effectiveStep, memoizedDispatch, postmortemState.changedFileds);
        if (effectiveStep >= 2) {
          setViewReport(true);
        }
      } else {
        errorNotification(
          `Please fill in all sections of the  ${postmortemPage}`
        );
        setStep(postmortemStep);
        handleModalClose();
        setUploading(false);
        return;
      }
    } catch (error) {
      console.error(error);
      handleModalClose();
    } finally {
      setUploading(false);
    }
  };

  // };

  const submitDataAndImages = async (mode) => {


    let currentObject = JSON.parse(JSON.stringify(currentPostmortemObject));
    let currentAuuditingObject = JSON.parse(JSON.stringify(postmortemObjectForAuditing));




    try {
      const submitDataPromise = submitData(
        mode,
        setDataIsSavedSuccessfully,
        setDataIsSubmittedSuccessfully,
        currentObject,
        postmortemState,
        memoizedDispatch,
        incidentID,
        setMessage,
        setStep,
        step,
        toast,
        postPostMortemData,
        addCollaboratorsinTeamsChatNew,
        instance,
        accounts,
        errMessage,
        setErrMessage,
        collaborators,
        setCollaborators,
        postmortemTeamId,
        loginRequest,
        setCurrentPostmortemObject,
        updateCache,
        fetchWithRetry,
      );
      const submitImagesPromise = saveImages(
        postmortemState,
        handleSuccess,
        step,
        incidentID,
        setImagesSavedSuccessfully,
        postImage
      );


      console.log("[AUDIT] Creating audit data promise for step:", step, "user:", graphData["username"]);
      const auditDataPromise = saveAuditData(
        postmortemState,
        currentAuuditingObject,
        postmortemID,
        postAuditData,
        step,
        graphData["username"],
        currentPostmortemObject,
        setCurrentPostmortemObject,
        setPostmortemObjectForAuditing
      )

      console.log("[AUDIT] Waiting for all promises (data, images, audit)...");
      await Promise.all([submitDataPromise, submitImagesPromise, auditDataPromise]);
      console.log("[AUDIT] All promises completed");


      removeImageFromContext(step, postmortemState, memoizedDispatch);
    } catch (error) {
      throw error;
    }
  };

  const handleSuccess = () => {
    setImagesSavedSuccessfully(true);
  };

  const saveAllSections = async () => {
    try {
      setUploading(true);
      const changedFileds = postmortemStateRef.current?.changedFileds || {};
      const hasStep0 = changedFileds.incSummDescription || changedFileds.preceEventsDescription || changedFileds.impact || changedFileds.detectionAndResponseDescription || changedFileds.mttd || changedFileds.mttrespond || changedFileds.mttrepair || changedFileds.mttrecover || changedFileds.portfolio || changedFileds.platform || changedFileds.product || changedFileds.app;
      const hasStep1 = changedFileds.recovery || changedFileds.rcidescription || changedFileds.rciquestions || changedFileds.rootCauseCode || changedFileds.rootCauseSubCode || changedFileds.causedByChangeNumber || changedFileds.causedByVendor || changedFileds.tags || changedFileds.recurringIssue || changedFileds.incidentId || changedFileds.problemId || changedFileds.impactedByChange || changedFileds.vendorDetails;
      const hasStep2 = changedFileds.pTasks || changedFileds.jiraTickets;

      if (!hasStep0 && !hasStep1 && !hasStep2) {
        successNotification("Nothing to save");
        return;
      }

      const tasks = [];
      if (hasStep0) tasks.push(autoSaveSection(0));
      if (hasStep1) tasks.push(autoSaveSection(1));
      if (hasStep2) tasks.push(autoSaveSection(2));
      await Promise.all(tasks);
    } catch (error) {
      console.error("Save failed:", error);
      errorNotification("Error saving data");
    } finally {
      setUploading(false);
    }
  };

  const autoSaveSection = async (sectionStep) => {
    try {
      const currentObject = JSON.parse(JSON.stringify(currentPostmortemObject));
      const currentAuditingObject = JSON.parse(JSON.stringify(postmortemObjectForAuditing));
      const latestState = postmortemStateRef.current;

      const postmortemData = getPostmortemData(
        currentObject,
        latestState,
        "saving",
        memoizedDispatch,
        sectionStep
      );

      const apiResponse = await postPostMortemData(
        apiEndpoint,
        incidentID,
        postmortemData
      );

      if (apiResponse.status === 200 || apiResponse.status === 201) {
        successNotification("Changes saved");
        // Exclude `status` (numeric API enum like 4) from being merged back into the context
        // object, otherwise `updateContextPostmortemState` will overwrite
        // `postmortemCurrentStatus.currentState` with the raw number (e.g. 4 instead of "TLTREVIEW")
        // and the STATE badge in the header will flip to the numeric value until refresh.
        const { status: _omitStatus, ...postmortemDataWithoutStatus } = postmortemData;
        setCurrentPostmortemObject((prev) => {
          const merged = { ...prev, ...postmortemDataWithoutStatus, __autoSave: true };
          // Deep-merge nested objects so that saving only one sub-field (e.g. mttrepair)
          // doesn't overwrite the entire parent object and wipe out unchanged fields
          // (e.g. mttd, mttrespond) that updateContextPostmortemState then re-dispatches as undefined.
          // Note: __autoSave flag tells PostmortemContext to skip re-dispatching the full
          // context state, preventing stale values from overriding correct context state.
          if (postmortemDataWithoutStatus.detectionResponse) {
            merged.detectionResponse = { ...prev.detectionResponse, ...postmortemDataWithoutStatus.detectionResponse };
          }
          if (postmortemDataWithoutStatus.incident_summary) {
            merged.incident_summary = { ...prev.incident_summary, ...postmortemDataWithoutStatus.incident_summary };
          }
          if (postmortemDataWithoutStatus.rootCause) {
            merged.rootCause = { ...prev.rootCause, ...postmortemDataWithoutStatus.rootCause };
          }
          if (postmortemDataWithoutStatus.rootCauseIdentificationRequest) {
            merged.rootCauseIdentificationRequest = { ...prev.rootCauseIdentificationRequest, ...postmortemDataWithoutStatus.rootCauseIdentificationRequest };
          }
          if (postmortemDataWithoutStatus.recurrence) {
            merged.recurrence = { ...prev.recurrence, ...postmortemDataWithoutStatus.recurrence };
          }
          return merged;
        });
        await reinitializeTheChangeValues(sectionStep, memoizedDispatch, latestState.changedFileds);

        // Use freshest state for image upload so we don't miss late dispatches
        const stateForImages = postmortemStateRef.current;
        const stagedImages = sectionStep === 0
          ? stateForImages.images?.incidentSummary
          : sectionStep === 1
            ? stateForImages.images?.rootCause
            : stateForImages.images?.preventiveCorrectiveMeasures;

        const hasImages = stagedImages && Object.values(stagedImages).some(arr => arr.length > 0);
        if (hasImages) {
          await saveImages(
            stateForImages,
            () => { },
            sectionStep,
            incidentID,
            setImagesSavedSuccessfully,
            postImage
          );
          removeImageFromContext(sectionStep, stateForImages, memoizedDispatch);
        }

        // Save audit data after successful save
        console.log("[AUDIT] autoSaveSection - saving audit data for step:", sectionStep);
        try {
          await saveAuditData(
            latestState,
            currentAuditingObject,
            postmortemID,
            postAuditData,
            sectionStep,
            graphData["username"],
            currentObject,
            setCurrentPostmortemObject,
            setPostmortemObjectForAuditing
          );
          console.log("[AUDIT] autoSaveSection - audit data saved successfully");
        } catch (auditError) {
          console.error("[AUDIT] autoSaveSection - audit save failed:", auditError);
          // Don't fail the whole save if audit fails
        }

        // ===== MAC AUTO-ADD AFTER SAVE (same as submitData) =====
        console.log('🚀 [AUTOSAVE] Starting MAC auto-add flow for section:', sectionStep);
        try {
          const appId = postmortemData.application_id;
          console.log('[AUTOSAVE_MAC] Starting auto-add flow:', {
            appId,
            postmortemTeamId,
            collaboratorsCount: collaborators?.length || 0,
            hasWindow: typeof window !== 'undefined',
            hasMacHelper: typeof window?.__macAutoAddOwners === 'function'
          });
          
          if (!postmortemTeamId) {
            console.error('❌ [AUTOSAVE_MAC] CRITICAL: postmortemTeamId is missing!');
            console.error('[AUTOSAVE_MAC] postmortemTeamId:', postmortemTeamId);
          } else if (appId) {
            try {
              const url = `${apiEndpoint}/macdata?appId=${encodeURIComponent(String(appId).toUpperCase())}`;
              console.log('[AUTOSAVE_MAC] Fetching MAC data from:', url);
              const macData = await fetchWithRetry(url);
              console.log('[AUTOSAVE_MAC] MAC data received:', macData);
              
              if (macData && typeof window !== 'undefined' && typeof window.__macAutoAddOwners === 'function') {
                console.log('[AUTOSAVE_MAC] Calling macAutoAddOwners...');
                await window.__macAutoAddOwners(macData, {
                  collaborators,
                  setCollaborators,
                  postmortemTeamId,
                  currentPostmortemObject: postmortemData,
                  instance,
                  accounts,
                  addCollaboratorsinTeamsChatNew,
                });
                console.log('[AUTOSAVE_MAC] ✓ Completed adding collaborators for APP ID:', appId);
              } else {
                console.error('[AUTOSAVE_MAC] ✗ Cannot call macAutoAddOwners');
              }
            } catch (macError) {
              console.error('[AUTOSAVE_MAC] ✗ MAC fetch error:', macError);
            }
          } else {
            console.log('[AUTOSAVE_MAC] ⊗ Skipping - No application_id');
          }
        } catch (macAutoAddError) {
          console.error('[AUTOSAVE_MAC] ✗ MAC auto-add failed:', macAutoAddError);
          // Don't fail the save if MAC auto-add fails
        }
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
      errorNotification("Save failed. Please try again.");
    }
  };

  return {
    postmortemState,
    memoizedDispatch,
    saveData,
    autoSaveSection,
    saveAllSections,
    step,
    setStep,
    openModal,
    handleModalClose,
    collaborators,
    setCollaborators,
    handleDataSubmit,
    setImagesSavedSuccessfully,
    uploading,
    dataIsSubmittedSuccessfully,
    dataIsSavedSuccessfully,
    viewReport,
    rcaChecking,
    rcaBlockOpen,
    rcaBlockData,
    setRcaBlockOpen,
    rcaQualityData,
    getRcaQuality,
    fetchEnhancement,
  };
};
